import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { Approval, MediaType } from '../core/types';
import { SubjectJsonModel } from '../subject/subject.json.model';
import { ConsumerJsonModel } from '../consumer/consumer.json.model';

export class FunctionalAudio extends JsonApiModel {
  @Field()
  public id!: string;

  @Field()
  public mediaType!: MediaType;

  @Field()
  public name!: string;
}

export class FunctionalImage extends JsonApiModel {
  @Field()
  public id!: string;

  @Field()
  public mediaType!: MediaType;

  @Field()
  public name!: string;
}

export class FunctionalHelpJsonModel extends JsonApiModel {
  public static override readonly type = 'functionalhelps';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public consumerId!: string;

  @Field()
  public exerciseKind!: string;

  @Field()
  public exerciseSubKind!: string;

  @Field()
  public name!: string;

  @Field()
  public subjectId!: string;

  @Field()
  public markdownText!: string;

  @Field()
  public markupText!: string;

  @Field()
  public desktopAudio!: FunctionalAudio | null;

  @Field()
  public mobileAudio!: FunctionalAudio | null;

  @Field()
  public image!: FunctionalImage | null;

  @Field()
  public approval!: Approval;

  @Field()
  public active!: boolean;

  @Field()
  public version!: number;

  @Field({
    parse: (value) => { return value ? new Date(value) : null; },
    serialize: (value) => { return value ? value.getTime().toString() : null; }
  })
  public updated!: Date;

  @Field()
  public changedBy!: string;

  // We do not need a relationship exercise.consumer. These getter/setters are here to assign from
  // AppState.consumers to each exerciseModel after GET
  // but do not send it back to backend on UPDATE / PATCH.
  private _consumer!: ConsumerJsonModel;
  public getConsumer(): ConsumerJsonModel { return this._consumer; }
  public setConsumer(value: ConsumerJsonModel) { this._consumer = value; }

  // Data from table competency
  private _competency!: SubjectJsonModel;
  public getCompetency(): SubjectJsonModel { return this._competency; }
  public setCompetency(value: SubjectJsonModel) { this._competency = value; }
}
